import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-book-open-line',
    title: '韩国漫画\n无删减原版',
    description: '所有漫画均为韩国原版无删减内容，完整呈现创作者的艺术表达，给你最真实的阅读体验。',
    link: '/category/fantasy',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读\n流畅体验',
    description: '采用下拉式阅读设计，无需翻页按钮，向下滑动即可连续阅读，如刷社交媒体般流畅自然。',
    link: '/category/romance',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '免费韩漫\n资源大全',
    description: '海量优质韩国漫画资源完全免费，覆盖奇幻、恋爱、悬疑等全品类，满足不同读者的口味需求。',
    link: '/category/suspense',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无广告\n纯净阅读',
    description: '告别烦人的弹窗和广告干扰，专注于阅读本身，享受纯粹沉浸式的漫画阅读时光。',
    link: '/category/school',
  },
];

export default function FeatureSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-medium border border-foreground-200/70 rounded-full text-foreground-600 mb-4 whitespace-nowrap">
            平台特色
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择韩漫大全？
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            我们致力于为韩漫爱好者提供最优质的阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg p-6 md:p-7 hover:bg-primary-50 transition-colors duration-300 group cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-5 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${feature.icon} text-lg text-secondary-600 group-hover:text-primary-500 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 whitespace-pre-line leading-snug">
                {feature.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                {feature.description}
              </p>
              <Link
                to={feature.link}
                className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-600 group-hover:text-primary-500 transition-colors duration-300 whitespace-nowrap"
              >
                了解更多
                <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}